import { Box, Stack, Text } from '@mantine/core';

type DetailRowPropsType = {
  label: string;
  children: React.ReactNode;
};

export const DetailRow: React.FC<DetailRowPropsType> = ({
  label,
  children,
}) => (
  <Stack gap={2}>
    <Text size="xs" c="dimmed">
      {label}
    </Text>
    <Box fz="sm">{children}</Box>
  </Stack>
);
